export default async function generateXml(context) {
  const res = context.res;
  const store = context.store;
  const route = context.route;
  const config = context.$config;
  const $axios = context.$axios;
  const $get = context.$get;

  try {
    const response = await $axios.request({
      url: '/api/news/?page_size=100000000000',
    });

    if (process.server) {
      const documentNews = response?.results;
      const baseUrl = '';

      const sitemap = `
      <?xml version="1.0" encoding="UTF-8"?>
      <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
        ${documentNews
          .map(({ id, original_url, create_date }) => {
            const lastUrl =
              original_url &&
              original_url.split('/').slice(-1)[0].replace('.chn', '.html');
            const mapDate = create_date
              ? new Date(create_date).toISOString()
              : new Date().toISOString();
            return `
                <url>
                  <loc>${baseUrl}/news/${id}/${lastUrl}</loc>
                  <lastmod>${mapDate}</lastmod>
                  <changefreq>monthly</changefreq>
                  <priority>1.0</priority>
                </url>
              `;
          })
          .join('')}
      </urlset>
      `;

      // res.setHeader('Content-Type', 'text/xml')
      // res.setHeader('Content-Type', 'application/xml')
      res.write(sitemap);
      res.end();

      console.log('[ Read Site Info ]', 'Success SiteId =');
    }
  } catch (e) {
    console.log('Read Site Info', 'is not available');
  }
}
